import React, { ReactNode } from 'react';
import { Order } from '../../../../types/interfaces';

// Один формат подписей и значений для всех секций развёрнутого
// заказа — такой же, как в DeliveryInfo. Раньше тут была отдельная
// 3-колоночная HTML-таблица (с p-[1.3rem]), это ломало выравнивание
// рядом с DeliveryInfo и съедало кучу места по ширине.
const Field: React.FC<{ label: string; value: ReactNode }> = ({
  label,
  value,
}) => (
  <div className="min-w-0">
    <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
      {label}
    </dt>
    <dd className="text-sm text-[#2d2c2c] break-words">{value}</dd>
  </div>
);

const Placeholder = ({ children }: { children: ReactNode }) => (
  <span className="text-gray-400">{children}</span>
);

export function ContactInfo({ order }: { order: Order }) {
  return (
    <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
      <Field
        label="ФИО"
        value={
          order.contact_full_name || <Placeholder>Не указано</Placeholder>
        }
      />
      <Field
        label="Телефон"
        value={
          order.contact_phone ? (
            <a
              href={`tel:${order.contact_phone}`}
              className="hover:text-[#e3282a] transition-colors"
            >
              {order.contact_phone}
            </a>
          ) : (
            <Placeholder>Не указан</Placeholder>
          )
        }
      />
      <Field
        label="Почта"
        value={
          order.contact_email ? (
            <a
              href={`mailto:${order.contact_email}`}
              className="hover:text-[#e3282a] transition-colors break-all"
            >
              {order.contact_email}
            </a>
          ) : (
            <Placeholder>Не указана</Placeholder>
          )
        }
      />
    </dl>
  );
}
